// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"d0f0b2a3","971":"48f9d244"}[chunkId] + ".chunk.css";
};